import React from 'react';
import PropTypes from 'prop-types';
import { LoadingOverlay } from '@ui/loading-spinner';
import { ErrorText } from '../ErrorText';
import { VisuallyHidden } from '../VisuallyHidden';
import {
  StyledRadioInput,
  Label,
  StyledFieldset,
  StyledLegend,
} from './styles.js';

export const Radio = ({
  choices,
  value,
  name,
  legendText,
  onChange,
  disabled,
  isLoading = false,
  direction = 'row',
  error,
  onClick,
  variant = 'light',
  showRadioIcon = true,
}) => {
  return (
    <>
      <StyledFieldset>
        <StyledLegend>{legendText}</StyledLegend>
        <StyledRadioInput direction={direction}>
          {choices.map(choice => {
            const isSelected = value === choice.value;
            const isChoiceDisabled = disabled && !isSelected;
            const showChoiceLoading = isLoading && isSelected;

            return (
              <Label
                showRadioIcon={showRadioIcon}
                checked={isSelected}
                disabled={isChoiceDisabled}
                error={error}
                htmlFor={`${name}-${choice.value}`}
                key={choice.value}
                variant={variant}
              >
                <VisuallyHidden>
                  <input
                    type="radio"
                    value={choice.value}
                    checked={isSelected}
                    id={`${name}-${choice.value}`}
                    onChange={e => onChange(e.target.value)}
                    error={error}
                    onClick={onClick}
                    disabled={disabled}
                    aria-busy={showChoiceLoading || undefined}
                  />
                </VisuallyHidden>
                <LoadingOverlay
                  isLoading={showChoiceLoading}
                  spinnerVariant="dark"
                >
                  {choice.name}
                </LoadingOverlay>
              </Label>
            );
          })}
        </StyledRadioInput>
        {error && <ErrorText>{error}</ErrorText>}
      </StyledFieldset>
    </>
  );
};

Radio.propTypes = {
  name: PropTypes.string.isRequired,
  choices: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string.isRequired,
      value: PropTypes.string.isRequired,
    }),
  ).isRequired,
  value: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  direction: PropTypes.oneOf(['row', 'column']),
  error: PropTypes.string,
  disabled: PropTypes.bool,
  isLoading: PropTypes.bool,
  onClick: PropTypes.func,
  legendText: PropTypes.string,
  variant: PropTypes.string,
};
